import React from 'react'
import PropTypes from 'prop-types'
import { getEstimatePastTime } from '@/checkout-instore-legacy/shipping/utils'
import { FormattedMessage } from 'react-intl'

const LastVisited = ({ lastSessionDate }) => (
  <div className="card-date-area c-muted-2">
    <FormattedMessage id="customerProfileLastVisit" />
    {': '}
    {getEstimatePastTime(new Date(lastSessionDate.data))}
  </div>
)

LastVisited.propTypes = {
  lastSessionDate: PropTypes.shape({
    data: PropTypes.string,
  }),
}

export default LastVisited
